import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-bulk-cancel-subscriptions',
		path: '/admin/bulk_cancel_subscriptions',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin-bulkCancelSubscriptions" */ './index'), {
			exportName: 'BulkCancelSubscriptions',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: ['support'],
		},
		frame: true,
	},
];
